import { render, staticRenderFns } from "./LaboratoryForm.vue?vue&type=template&id=7e3cb75a"
import script from "./LaboratoryForm.vue?vue&type=script&lang=js"
export * from "./LaboratoryForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports